/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/*
 * Using this json only for 18F brand.
 */
const data = {
    heading: '7 Mindful Ways to Be a Good Listener',
    multi_description: [
        {
            center: true,
            italic: true,
            strong: 'It\'s really not that hard. Here are seven habits of mindful listeners',
        },
        {
            center: true,
            italic: true,
            strong: 'By Marla Schuchman',
        },
        {
            image_url: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2018/articles/seven-mindful-ways-to-be-a-good-listener-banner.jpg?height=564&width=1094',
        },
        {
            content: 'Has this ever happened to you? You\'re in a conversation with a friend, and you\'re telling someone about your crappy day or your ridiculous coworker. Or maybe you\'re telling them that you ate a slice of mediocre cheesecake this afternoon and boom, you\'re thrown off your superficial rant.',
        },
        {
            content: 'Why? Because suddenly you\'re having visions of your mother\'s famous cheesecake that she made every year for a spring party. You miss that cheesecake. You miss your mother. You just got hit with a wall of emotion, and now you\'re kind of teary eyed but also a little embarrassed and somewhat anxious that you might be judged for bringing that up again.',
        },
        {
            content: 'And what\'s your friend supposed to do at this moment? Tell you she\'s sorry? Heck no! It\'s been eight years and you\'re still choking up about cheesecake. What good will her telling you sorry do for you today?',
        },
        {
            content: 'What helps the most is just being a great listener. All you need in this moment is to be heard, to be understood, and to be able to experience whatever feelings you are experiencing without piling on others like shame, discomfort or awkwardness.',
        },
        {
            content: 'In times of high emotion, this little act of just listening has big, transformative powers. Simply put, a great listener doesn\'t have to say much to make you feel better. In fact, a great listener barely says anything at all. If they did, they wouldn\'t be listening. So how do people actually become great listeners? The good news is, it\'s easy to do at any age.',
        },
        {
            content: 'There are several ways a person can work on their listening skills. Active Listening, a subset of high-level interpersonal communications skills, is particularly well known for its transformative powers. When a person engages in Active Listening, he or she is focused almost exclusively on the other person.',
        },
        {
            strong: 'The following elements are key when practicing Active Listening:',
            list: [
                {
                    strong: 'Understand that this isn\'t a conversation in the normal sense of the word.',
                    content: ' The person speaking should be talking 70-80% of the time. When the listener speaks, it\'s usually to ask a question to draw out more of the person\'s experience, or to clarify something that has been said.',
                },
                {
                    strong: 'Demonstrate genuine empathy for the other person.',
                    content: ' As they speak, imagine what they could be feeling or thinking. Pretend you are right there with them. When it\'s your turn to speak, your responses will naturally mimic these complex emotions.',
                },
                {
                    strong: 'Don\'t just wait to talk and blurt out something profound that you\'ve been cooking up while the other person told you their sob story.',
                    content: ' This isn\'t a competition about whose comment is the most insightful, sad, or meaningful. Your goal isn\'t to add words to the conversation; it\'s to create a supportive and caring framework for the other person to feel comfortable sharing what\'s on their mind.',
                },
                {
                    strong: 'Show you really heard what the other person said.',
                    content: ' Reflect the content of their story by parroting it vnymore," a good response would be, "You haven\'t had your mother\'s cheesecake in a long time." It might sound plain and unadorned, but it works.',
                },
                {
                    strong: 'Pay close attention and resist the urge to check your phone or change the topic.',
                    content: ' Offer reassuring words or phrases as the other person speaks. When uttered genuinely, fillers like "mmhmm", "OK," and "I see" let the other person know you\'re still present.',
                },
                {
                    strong: 'Try not to interrupt.',
                    content: ' Yes, we all do it sometimes, but when a person is hurting, it\'s doubly rude. Just keep your comments to yourself by any means possible.',
                },
                {
                    strong: 'Be OK with long pauses.',
                    content: ' Since you\'re not interrupting, and you\'re letting the other person talk the majority of the time, you\'ll likely feel a bit of a slower pace to the conversation. This is OK. Long pauses give the other person time to fill in the blanks, share with you more information, and process out loud the emotions inside.',
                },
            ],
        },
        {
            content: 'Overall, a great listener makes the other person feel like they are the only one in the world; a feeling that\'s rare in these days of continual sensory overload. A great listener helps the other person get to the core of what\'s bothering them at that moment, so they can verbalize it and start to move forward. A great listener knows that when you\'re on another one of your cheesecake tangents, the best thing to do is support you as you re-experience your deep loss fully and completely in that moment, cherry topping and all.',
        },
        {
            center: true,
            strong: 'A version of this piece originally ran on modernloss.com',
        },
    ],
};

export default data;
